export enum DashSelfServeReconciliationMatchType {
    Exact = 1,
    Partial = 2
}